<template>
  <div class="map-type" :class="[menu ? 'opened-menu-bottom' : '']">
    <mf-tabs-button v-model="localMapType" size="sm" :buttons="toggleButtons" @change="$emit('change')" />
  </div>
</template>

<script>
export default {
  props: {
    menu: Boolean,
    mapType: String,
  },
  computed: {
    localMapType: {
      get() {
        return this.mapType
      },
      set(value) {
        this.$emit('update:mapType', value)
      },
    },
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Agrupamento',
          icon: 'group_work',
          value: 'agrupamentos',
          active: true,
        },
        {
          id: 1,
          label: 'Mapa de calor',
          icon: 'local_fire_department',
          value: 'calor',
          active: true,
        },
        {
          id: 2,
          label: 'Pontos',
          icon: 'scatter_plot',
          value: 'pontos-tile',
          active: true,
        },
      ]
    },
  },
}
</script>
